import { render, staticRenderFns } from "./CalculatorForInput.vue?vue&type=template&id=3ffa871c&"
import script from "./CalculatorForInput.vue?vue&type=script&lang=js&"
export * from "./CalculatorForInput.vue?vue&type=script&lang=js&"
import style0 from "./CalculatorForInput.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports